import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/cn';

import { Icon, type IconName } from './Icon';

type Tone = 'info' | 'success' | 'warning' | 'danger';

// A faixa da esquerda e o icone repetem o tom; o titulo e o texto continuam dizendo o
// que aconteceu, para quem nao distingue as cores.
const tones: Record<Tone, string> = {
  info: 'bg-info-50 text-info-700 border-info-200 shadow-[inset_3px_0_0_var(--color-info-500)]',
  success:
    'bg-success-50 text-success-700 border-success-200 shadow-[inset_3px_0_0_var(--color-success-500)]',
  warning:
    'bg-warning-50 text-warning-700 border-warning-200 shadow-[inset_3px_0_0_var(--color-warning-500)]',
  danger:
    'bg-danger-50 text-danger-700 border-danger-200 shadow-[inset_3px_0_0_var(--color-danger-500)]',
};

const icones: Record<Tone, IconName> = {
  info: 'info',
  success: 'check',
  warning: 'alert',
  danger: 'alert',
};

export function Alert({
  tone = 'info',
  title,
  children,
  className,
}: {
  tone?: Tone;
  title?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      // Erro e aviso sao anunciados assim que aparecem. Sem isso, quem usa leitor
      // de tela nao percebe que o formulario falhou.
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cn(
        'flex gap-3 rounded-xl border py-3 pr-4 pl-4 text-sm',
        tones[tone],
        className,
      )}
    >
      <Icon name={icones[tone]} size={18} className="mt-px shrink-0" />
      <div className="min-w-0 flex-1">
        {title ? <p className="mb-0.5 font-semibold">{title}</p> : null}
        <div className="text-[0.8125rem] leading-relaxed">{children}</div>
      </div>
    </div>
  );
}
